 // Email verification on login page
    
 const btnFormLogin = document.getElementById('CustomerEmail');
 btnFormLogin.addEventListener('change', verifyEmail);

 function verifyEmail() {
     const inputEmail = document.getElementById('CustomerEmail');
     const inputLabel = document.getElementById('inputLabel');
     const errorMessage = document.querySelector('.main-login__error-massage');
     const errorBlock = document.querySelector('.main-login__error-block');
     const emailRegEx = /(?:[a-z0-9+!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;
     const input = document.querySelector("#CustomerEmail");
     
         if ( !input.value.match( emailRegEx )) {
                 inputEmail.classList.add('main-login__input--error-border');
                 inputLabel.classList.add('main-login__input--error-label');
                 errorMessage.style.display = "block";
                 errorBlock.style.display = "none";
                 input.placeholder = "InvalidValue";
         }
         else {
           inputEmail.classList.remove('main-login__input--error-border');
           inputLabel.classList.remove('main-login__input--error-label');
           errorMessage.style.display = "none";
           errorBlock.style.display = "none";
         }
 }